import { render, staticRenderFns } from "./leaderDetail.vue?vue&type=template&id=ace54ec2&scoped=true"
import script from "./leaderDetail.vue?vue&type=script&lang=js"
export * from "./leaderDetail.vue?vue&type=script&lang=js"
import style0 from "./leaderDetail.vue?vue&type=style&index=0&id=ace54ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace54ec2",
  null
  
)

export default component.exports